'use client'

import { useAuthContext } from '@/features/auth/contexts/AuthContext'
import { cn } from '@/shared/lib/utils'

import { authCtaClassName } from '../../constants/styles'

type SignInButtonProps = React.ComponentProps<'button'>

export function SignInButton({ children, className, ...props }: SignInButtonProps) {
  const { isLoading } = useAuthContext()

  return (
    <button
      type="submit"
      disabled={isLoading}
      className={cn(authCtaClassName, className)}
      {...props}
    >
      {isLoading ? (
        <>
          <span>
            <i className="fad fa-spinner-third fa-spin" />
          </span>{' '}
          Entrando...
        </>
      ) : (
        children ?? 'Entrar'
      )}
    </button>
  )
}
